/**
 * 统一声明一个函数，
 * App可调这方法，传函数名执行相当于代码，
 * 再通过window异步通知App
 *
 * appBridge('函数名')
 * 封装统一一个方法给App，
 * 比如App想获取 getMicQueueList 就 appBridge('getMicQueueList')。
 * 返回给App 是 JSON.stringify(message) ，message 格式是 {type: '函数名',data: 数据}
 * 然后App统一处理
 * **/
export default defineNuxtPlugin(() => {
  //#region appBridge 客户端调用web端方法封装
  const rnFun: any = {
    getNative: 'native'
  }
  // 提前声明方法提供给App调取模块
  // 提前声明函数名，有函数命才可以调取
  // const appBridgeFunNames = {
  //   socketMessage: 'socketMessage', // socket Message
  //   exitChatRoom: 'exitChatRoom', // AppSocket退出房间
  //   sendGetTime: 'sendGetTime', // 获取房间计时
  //   openGift: 'openGift', // 在房间打开礼物弹窗
  //   openTool: 'openTool', // 打开房间工具栏（App在游戏会用到）
  //   keepRoom: 'keepRoom', // 最小退出 {isKeepRoom: true/最小化开启，false最小化关闭}
  //   insufficientBalance: 'insufficientBalance', // 余额不足
  //   openSharePopup: 'openSharePopup', // 打开分享弹窗
  //   microphoneSwitch: 'microphoneSwitch', // 麦克风开关
  //   soundSwitch: 'soundSwitch' // 声音开关
  // }
  const roomStore = useRoomStore()
  // const callStore = useCallStore()
  const agoraStore = useAgoraStore()
  const trtcStore = useTrtcStore()
  const socketStore = useSocketStore()
  const audioStore = useAudioStore()
  const appBridgeFunNames = {
    socketMessage: (data) => {
      // 心跳路由不console.log
      if (data.route !== 'heartbeat') {
        console.log('appBridge => socketMessage', data)
      }
      socketStore.onMsg(typeof data === 'string' ? JSON.parse(data) : data)
    }, // socket Message
    exitChatRoom: (data) => {
      console.log('appBridge => exitChatRoom', data)
      // 退出房间重置SDK数据
      if (roomStore.rtcInfo.rtcType === 'AGORA') {
        agoraStore.leave()
      } else {
        trtcStore.exit()
      }
    }, // AppSocket退出房间
    microphoneSwitch: (data) => {
      console.log('🚀 ~ file: Audio.vue:55 ~ microphoneSwitch:', data)
      audioStore.setIsOpenLocalMin(data)
      audioStore.manageLocalAudioMicrophone(data)
    }, // 麦克风开关
    soundSwitch: (data) => {
      console.log('🚀 ~ file: Audio.vue:55 ~ isOpenSound:', data)
      audioStore.switchAllRemoteAudioTrack(data)
      // 该方法不需要回调客户端
    } // 声音开关
  }
  const appGetMessageFun = {
    sendGetTime: 'sendGetTime'
  }
  /**
   * 安卓和IOS可以直接调这个方法获取数据
   * @param {string} funName 函数名
   * @param {object} data 需要传递的数据
   */
  function appBridge(funName: string, data: { [key: string]: any } | boolean) {
    const version = common.checkVersion()
    // 校验环境 && 没有函数名 就return
    if (version.app && !appBridgeFunNames[funName]) return

    // const roomStore = useRoomStore()
    // // const callStore = useCallStore()
    // const agoraStore = useAgoraStore()
    // const trtcStore = useTrtcStore()
    // const socketStore = useSocketStore()
    // const audioStore = useAudioStore()
    // const rechargeStore = useRechargeStore()

    // 设置数据，最后会转成JSONString
    const message = {
      type: funName, // 函数名
      data: null as any // 数据
    }
    // switch (funName) {
    //   // socket回调的消息
    //   case appBridgeFunNames.socketMessage:
    //     // 心跳路由不console.log
    //     if (data.route !== 'heartbeat') {
    //       console.log('appBridge => socketMessage', data)
    //     }
    //     socketStore.onMsg(typeof data === 'string' ? JSON.parse(data) : data)
    //     break
    //   // AppSocket退出房间
    //   case appBridgeFunNames.exitChatRoom:
    //     console.log('appBridge => exitChatRoom', data)
    //     // 退出房间重置SDK数据
    //     if (roomStore.rtcInfo.rtcType === 'AGORA') {
    //       agoraStore.leave()
    //     } else {
    //       trtcStore.exit()
    //     }
    //     break
    //   // 麦克风开关
    //   case appBridgeFunNames.microphoneSwitch:
    //     console.log('🚀 ~ file: Audio.vue:55 ~ microphoneSwitch:', data)
    //     audioStore.setIsOpenLocalMin(data)
    //     audioStore.manageLocalAudioMicrophone(data)
    //     // 该方法不需要回调客户端
    //     return
    //   // 声音开关
    //   case appBridgeFunNames.soundSwitch:
    //     console.log('🚀 ~ file: Audio.vue:55 ~ isOpenSound:', data)
    //     audioStore.switchAllRemoteAudioTrack(data)
    //     // 该方法不需要回调客户端
    //     return
    //   // App获取房间计时
    //   // case appBridgeFunNames.sendGetTime:
    //   //   message.data = callStore.callTime
    //   //   break
    //   // 在房间打开礼物弹窗
    //   // case appBridgeFunNames.openGift:
    //   //   AppNative.appFun(
    //   //     AppNative.iosNeedMessageFun.giftPopup,
    //   //     JSON.stringify({
    //   //       list: [...audioStore.inMicQueueList],
    //   //       active: null
    //   //     })
    //   //   )
    //   //   break
    //   // 打开房间工具栏（App在游戏会用到）
    //   // case appBridgeFunNames.openTool:
    //   //   emitter.emit('openToolsPopup')
    //   //   break
    //   // // app最小化退出房间
    //   // case appBridgeFunNames.keepRoom:
    //   //   roomStore.setQuitRoomType(data.isKeepRoom ? 2 : 0)
    //   //   break
    //   // // 余额不足提示
    //   // case appBridgeFunNames.insufficientBalance:
    //   //   rechargeStore.getAppFirstChargeInfo()
    //   //   break
    //   // // 打开分享弹窗
    //   // case appBridgeFunNames.openSharePopup:
    //   //   emitter.emit('openSharePopup')
    //   //   break
    // }
    appBridgeFunNames[funName](data)
    // 判断是否需要回调给App
    if (appGetMessageFun[funName]) {
      if (version.ios) {
        let appObj: any = {}
        if (window['webkit'].messageHandlers[funName]) {
          appObj = window['webkit'].messageHandlers
        } else {
          appObj = window['ReactNativeWebView']
        }
        // eslint-disable-next-line no-prototype-builtins
        if (appObj.hasOwnProperty('postMessage')) {
          appObj.postMessage(JSON.stringify(message.data))
        } else {
          if (rnFun[funName]) {
            return
          }
          appObj[funName] &&
            appObj[funName].postMessage(JSON.stringify(message.data))
        }
      } else {
        // Android 调用方式
        const appObj = window['androidJsObj']
        appObj[funName](JSON.stringify(message.data))
      }
    }
  }
  window['appBridge'] = appBridge
  //#endregion

  //#region web方法具体处理
  //#endregion
})
